/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

export function numberWithCommas(x: number): string {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function removeNewlines(text: string): string {
  return text.replace(/(\r \n|\n|\r)/gm, "");
}

export function removeQueryParams(link: string): string {
  const splitLink = link.split("?");
  return splitLink[0];
}
